import React from "react";
import { Dropdown, Header } from "semantic-ui-react";

const Preferenze = ({
  selectedArea,
  setSelectedArea,
  selectedSpecialita,
  setSelectedSpecialita,
  selectedLivello,
  setSelectedLivello,
  selectedLingua,
  setSelectedLingua,
  selectedNumAllevi,
  setSelectedNumAllevi,
  datiScuola,
}) => {
  // Transform data for Semantic UI Dropdown format
  const areaOptions = Object.entries(datiScuola?.areeOperative || {}).map(
    ([id, name]) => ({
      key: id,
      value: id,
      text: name,
    })
  );

  const specialitaOptions = Object.entries(
    datiScuola?.["specialità"] || {}
  ).map(([id, obj]) => ({
    key: id,
    value: id,
    text: obj.text,
  }));

  const livelloOptions = Object.entries(datiScuola?.livelli || {}).map(
    ([id, obj]) => ({
      key: id,
      value: id,
      text: obj.text,
    })
  );

  const linguaOptions = Object.values(datiScuola?.linguePrivate || {}).map(
    (lingua) => ({
      key: lingua.id,
      value: lingua.id,
      text: lingua.isoCode,
    })
  );

  const numAlleviOptions = [1, 2, 3, 4, 5].map((num) => ({
    key: num,
    value: num,
    text: num.toString(),
  }));

  return (
    <div>
      <Header as="h2">Preferenze</Header>

      {/* Area Operativa */}
      <div style={{ marginBottom: "1rem" }}>
        <label style={{ display: "block", marginBottom: "0.5rem" }}>
          Area Operativa:
        </label>
        <Dropdown
          placeholder="Seleziona area"
          fluid
          selection
          options={areaOptions}
          value={selectedArea || ""}
          onChange={(e, { value }) => setSelectedArea(value)}
        />
      </div>

      {/* Specialità */}
      <div style={{ marginBottom: "1rem" }}>
        <label style={{ display: "block", marginBottom: "0.5rem" }}>
          Specialità:
        </label>
        <Dropdown
          placeholder="Seleziona specialità"
          fluid
          selection
          options={specialitaOptions}
          value={selectedSpecialita || ""}
          onChange={(e, { value }) => setSelectedSpecialita(value)}
        />
      </div>

      {/* Livello */}
      <div style={{ marginBottom: "1rem" }}>
        <label style={{ display: "block", marginBottom: "0.5rem" }}>
          Livello:
        </label>
        <Dropdown
          placeholder="Seleziona livello"
          fluid
          selection
          options={livelloOptions}
          value={selectedLivello || ""}
          onChange={(e, { value }) => setSelectedLivello(value)}
        />
      </div>

      {/* Lingua */}
      <div style={{ marginBottom: "1rem" }}>
        <label style={{ display: "block", marginBottom: "0.5rem" }}>
          Lingua:
        </label>
        <Dropdown
          placeholder="Seleziona lingua"
          fluid
          selection
          options={linguaOptions}
          value={selectedLingua || ""}
          onChange={(e, { value }) => setSelectedLingua(value)}
        />
      </div>

      {/* Numero Allievi */}
      <div style={{ marginBottom: "1rem" }}>
        <label style={{ display: "block", marginBottom: "0.5rem" }}>
          Numero Allievi:
        </label>
        <Dropdown
          placeholder="Seleziona numero"
          fluid
          selection
          options={numAlleviOptions}
          value={selectedNumAllevi || ""}
          onChange={(e, { value }) => setSelectedNumAllevi(value)}
        />
      </div>
    </div>
  );
};

export default Preferenze;
